import { ActionsCell } from "../../../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../../../Component/Common/Components/DataTable/DefaultCell";
import { Individual } from "../../../../../Component/Model/Dto/Individual";
import { ActionType, TableColumn } from "../../../../../Component/Model/Table/Table";
import { currencyFormatterNoDecimal } from "../../../../../Helpers/CurrencyFormatter";


interface EmployeeSalariesRow {
    Id:                     number;
    IdentificationNumber:   string;
    EmployeeCode:           string;
    FirstName:              string;
    LastName:               string;
    Race:                   string;
    Gender:                 string;
    Disabled:               string;
    TotalSalary:            string;
    Actions:                ActionType[];
}

export interface EmployeeSalariesTable {
    columns: Array<TableColumn>;
    rows: Array<EmployeeSalariesRow>;
}

export function EmployeeSalariesWithActionsTableMapper_Old(dataObject: Individual.SalarySummaryDtoIn[], handleEdit: (id: number) => void, isEditable: boolean): EmployeeSalariesTable {
    const columns = [
        { Header: 'ID Number', accessor: 'IdentificationNumber', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true},
        { Header: 'Employee Code', accessor: 'EmployeeCode', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true},
        { Header: 'Name', accessor: 'FirstName', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true}/> },
        { Header: 'Surame', accessor: 'LastName', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true}/> },
        { Header: 'Race', accessor: 'Race', id:'RaceId', Cell: ({ value }: any) => <DefaultCell value={value}/> },
        { Header: 'Gender', accessor: 'Gender', id:'GenderId', Cell: ({ value }: any) => <DefaultCell value={value}/> },
        { Header: 'Disabled', accessor: 'Disabled', Cell: ({ value }: any) => <DefaultCell value={value}/> },
        { Header: 'Total Salary', accessor: 'TotalSalary', Cell: ({ value }: any) => <DefaultCell value={value}/>, disableSortBy: true },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];

    if (dataObject !== undefined && dataObject.length > 0){
        const rows = dataObject.map((item: Individual.SalarySummaryDtoIn) => ({
            Id: item.IndividualId,
            IdentificationNumber: item.IdentificationNumber,
            EmployeeCode: item.EmployeeCode,
            FirstName: item.FirstName,
            LastName: item.LastName,
            Race: item.Race,
            Gender: item.Gender,
            Disabled: item.Disabled ? 'Yes' : 'No',
            TotalSalary: currencyFormatterNoDecimal(item.TotalSalary),
            Actions: [
                isEditable ?
                    {
                        label: 'Edit Salaries',
                        action: () => {handleEdit(item.IndividualId)},
                        key: item.IndividualId.toString(),
                        icon: { color: 'info', name: 'edit' }
                    } :
                    {
                        label: 'View Salaries',
                        action: () => {handleEdit(item.IndividualId)},
                        key: item.IndividualId.toString(),
                        icon: { color: 'info', name: 'visibility' }
                    }
            ]

        }));

        return { columns: columns, rows: rows };

    }else {
        return { columns: columns, rows: [] };
    }
}


interface EmployeeSalariesConsolidationRow extends EmployeeSalariesRow {
    SourceScorecardName: string;
}

interface EmployeeSalariesConsolidationTable {
    columns: Array<TableColumn>;
    rows: Array<EmployeeSalariesConsolidationRow>;
}

export function EmployeeSalariesConsolidationWithActionsTableMapper_Old(dataObject: Individual.SalarySummaryDtoIn[], handleEdit: (id: number) => void, isEditable: boolean): EmployeeSalariesConsolidationTable {
    const columns = [
        { Header: 'ID Number', accessor: 'IdentificationNumber', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true},
        { Header: 'Employee Code', accessor: 'EmployeeCode', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true},
        { Header: 'Name', accessor: 'FirstName', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true}/> },
        { Header: 'Surame', accessor: 'LastName', Cell: ({ value }: any) => <DefaultCell value={value} tooltip={true}/> },
        { Header: 'Race', accessor: 'Race', id:'RaceId', Cell: ({ value }: any) => <DefaultCell value={value}/> },
        { Header: 'Gender', accessor: 'Gender', id:'GenderId', Cell: ({ value }: any) => <DefaultCell value={value}/> },
        { Header: 'Disabled', accessor: 'Disabled', Cell: ({ value }: any) => <DefaultCell value={value}/> },
        { Header: 'Total Salary', accessor: 'TotalSalary', id:'TotalSalary', Cell: ({ value }: any) => <DefaultCell value={value}/>, disableSortBy: true  },
        { Header: 'Source Scorecard', accessor: 'SourceScorecardName', Cell: ({ value }: any) => <DefaultCell value={value} />, disableSortBy: true  },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];

    if (dataObject !== undefined && dataObject.length > 0){
        const rows = dataObject.map((item: Individual.SalarySummaryDtoIn) => ({
            Id: item.IndividualId,
            IdentificationNumber: item.IdentificationNumber,
            EmployeeCode: item.EmployeeCode,
            FirstName: item.FirstName,
            LastName: item.LastName,
            Race: item.Race,
            Gender: item.Gender,
            Disabled: item.Disabled ? 'Yes' : 'No',
            TotalSalary: currencyFormatterNoDecimal(item.TotalSalary),
            SourceScorecardName: item.SourceScorecardName,
            Actions: [
                isEditable ?
                    {
                        label: 'Edit Salaries',
                        action: () => {handleEdit(item.IndividualId)},
                        key: item.IndividualId.toString(),
                        icon: { color: 'info', name: 'edit' }
                    } :
                    {
                        label: 'View Salaries',
                        action: () => {handleEdit(item.IndividualId)},
                        key: item.IndividualId.toString(),
                        icon: { color: 'info', name: 'visibility' }
                    }
            ]
            
        }));

        return { columns: columns, rows: rows };
        
    }else {
        return { columns: columns, rows: [] };
    }
}